module.exports = __webpack_public_path__ + "img/s2.34bf1edd.png";